import { doPrivateGetRequest, doPrivatePostRequest } from "./requests";

export const getAudioSecureUrl = (_meets_id, _token) => {
  const path = `/audio/api/secure-section-url/${encodeURIComponent(_meets_id)}`;
  return doPrivateGetRequest(path, _token);
};

export const getAudioDownloadUrl = (_meets_id, _token) => {
  const path = `/audio/api/download-section/${encodeURIComponent(_meets_id)}`;
  return doPrivateGetRequest(path, _token);
};

export const getUserRecordingsStats = (_user_id, _token) => {
  const path = `/audio/api/stats`;

  const params = {
    user_id: "current",
  };

  return doPrivatePostRequest(params, path, _token);
};

export const getUserRecordings = (_user_id, _dr, _token) => {
  const path = `/audio/api/get/audio-meets`;

  const params = {
    user_id: _user_id,
    dr: _dr,
  };

  return doPrivatePostRequest(params, path, _token);
};

export const processAudio = (_doc_id, _token) => {
  const path = `/audio/api/reprocess/audio/files/${_doc_id}`

  return doPrivateGetRequest(path, _token)
}
